import { useCallback, useState } from 'react';

import { Schedule } from '@mint-sdk/api-ai-assistant';

import { useToggleScheduleDialog } from '../../../hooks/useToggleScheduleDialog.jsx';

const setInitialDate = (date?: string) => {
  return date ? new Date(date + 'Z') : undefined;
};

type FieldState = {
  scheduling: Schedule.QueryScheduleSchemaType['scheduling'] | '';
  from?: Date;
  to?: Date;
  chatName: string;
  time: Date | null;
  query: string;
};

export const useDialogValues = () => {
  const { editQuery } = useToggleScheduleDialog();

  const [fields, setFields] = useState<FieldState>(() => ({
    scheduling: editQuery?.scheduling || '',
    from: setInitialDate(editQuery?.startDate),
    to: setInitialDate(editQuery?.endDate),
    chatName: editQuery?.chatTitle || '',
    time: editQuery?.startDate ? new Date(editQuery?.startDate + 'Z') : null,
    query: editQuery?.query || '',
  }));

  const updateField = useCallback(
    <K extends keyof FieldState>(key: K, value: FieldState[K]) => {
      setFields((prev) => ({ ...prev, [key]: value }));
    },
    [],
  );

  return {
    fields,
    updateField,
  };
};
